/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Empty_Kind_HintInputs */

const cs_documents_empty_kind_hint = /** @type {(inputs: Documents_Empty_Kind_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zkuste jinou kategorii vlevo, nebo zobrazte všechny složky.`)
};

const en_documents_empty_kind_hint = /** @type {(inputs: Documents_Empty_Kind_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pick another category on the left, or show all folders.`)
};

/**
* | output |
* | --- |
* | "Pick another category on the left, or show all folders." |
*
* @param {Documents_Empty_Kind_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_empty_kind_hint = /** @type {((inputs?: Documents_Empty_Kind_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Empty_Kind_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_empty_kind_hint(inputs)
	return cs_documents_empty_kind_hint(inputs)
});